import { RegisterOptions } from 'react-hook-form';
import { HandbookRegistration } from 'types';

export type HandbookRegistrationUI = Omit<
    HandbookRegistration,
    | 'language'
    | 'captchaCode'
    | 'utmTerm'
    | 'utmMedium'
    | 'utmSource'
    | 'agreement'
    | 'utmCampaign'
    | 'utmContent'
>;

export const getHandbookRegistrationFormRules = (
    t: (key: string, options?: Record<string, number | string>) => string
): Record<keyof HandbookRegistrationUI, RegisterOptions> => ({
    name: {
        required: {
            value: true,
            message: t('required-field', {
                ns: 'common/errors',
            }),
        },
        maxLength: {
            value: 50,
            message: t('max-length', {
                ns: 'common/errors',
                length: 50,
            }),
        },
    },
    email: {
        required: {
            value: true,
            message: t('required-field', {
                ns: 'common/errors',
            }),
        },
        maxLength: {
            value: 254,
            message: t('max-length', {
                ns: 'common/errors',
                length: 254,
            }),
        },
        pattern: {
            value: /\S+@\S+\.\S+/,
            message: t('email-format', {
                ns: 'common/errors',
            }),
        },
    },
    country: {
        required: {
            value: true,
            message: t('required-field', {
                ns: 'common/errors',
            }),
        },
        maxLength: {
            value: 254,
            message: t('max-length', {
                ns: 'common/errors',
                length: 254,
            }),
        },
    },
    profession: {
        maxLength: {
            value: 254,
            message: t('max-length', {
                ns: 'common/errors',
                length: 254,
            }),
        },
    },
    howAreYouGoingToUse: {
        required: {
            value: true,
            message: t('required-field', {
                ns: 'common/errors',
            }),
        },
    },
    other: {
        required: {
            value: true,
            message: t('required-field', {
                ns: 'common/errors',
            }),
        },
        maxLength: {
            value: 254,
            message: t('max-length', {
                ns: 'common/errors',
                length: 254,
            }),
        },
    },
});
